<form #deputyForm="ngForm">
  <div class="row">
    <div class="form-group col-md-3 hasValue" [class.has-error]="!deputy.empId">
      <label>{{ "Employee" | translate }}</label>
      <kendo-dropdownlist
        [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }"
        [filterable]="true"
        [(ngModel)]="deputy.empId"
        name="empId"
        required
        [(value)]="deputy.empId"
        [textField]="'fullName'"
        [valueField]="'id'"
        [data]="employees"
      >
      </kendo-dropdownlist>
    </div>
    <div
      class="form-group col-md-3 hasValue"
      [class.has-error]="!deputy.substituteId"
    >
      <label>{{ "Deputy" | translate }}</label>
      <kendo-dropdownlist
        [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }"
        [filterable]="true"
        [(ngModel)]="deputy.substituteId"
        name="substituteId"
        [(value)]="deputy.substituteId"
        required
        [textField]="'fullName'"
        [valueField]="'id'"
        [data]="substituteEmployees"
      >
      </kendo-dropdownlist>
    </div>
    <div
      class="form-group col-md-3 hasValue"
      [class.has-error]="!deputy.startDate"
    >
      <label>{{ "startDate" | translate }}</label>
      <kendo-datepicker
        name="startDate"
        [format]="'dd.MM.yyyy'"
        [(ngModel)]="deputy.startDate"
        #startDate="ngModel"
        required
        [(value)]="deputy.startDate"
      >
        <kendo-datepicker-messages
          today="{{ 'startDate' | translate }}"
        ></kendo-datepicker-messages>
      </kendo-datepicker>
    </div>
    <div
      class="form-group col-md-3 hasValue"
      [class.has-error]="!deputy.endDate"
    >
      <label>{{ "endDate" | translate }}</label>
      <kendo-datepicker
        name="endDate"
        [format]="'dd.MM.yyyy'"
        [(ngModel)]="deputy.endDate"
        #startDate="ngModel"
        required
        [(value)]="deputy.endDate"
      >
        <kendo-datepicker-messages
          today="{{ 'End Date' | translate }}"
        ></kendo-datepicker-messages>
      </kendo-datepicker>
    </div>
  </div>
  <button
    kendoButton
    type="button"
    (click)="deleteDeputy()"
    class="btn remove"
    [icon]="'trash'"
  ></button>
</form>
<div class="modal-footer">
  <button
    class="btn-save"
    (click)="saveDeputy()"
    [disabled]="!deputyForm.valid"
    kendoButton
    primary="true"
  >
    {{ "save" | translate }}
  </button>
  <button
    kendoButton
    class="btn-cancel"
    (click)="closeDialog()"
    type="button"
    primary="true"
  >
    {{ "conclude" | translate }}
  </button>
</div>
